// extracted by mini-css-extract-plugin
export default {"Carousel":"Carousel_Carousel__B5Zv-","carouselItem":"Carousel_carouselItem__gsgD-"};